import { Card, CardBody, Col } from "reactstrap";
import { fileUploadData } from "../../../../Data/BonusUiData/DropzoneData";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import CommonFileUpload from "../../../../Utils/CommonComponents/CommonFileUpload";
import { SingleFileuploadTitle } from "../../../../Utils/Constants";

export default function SingleFileupload() {
  return (
    <Col lg={6}>
      <Card>
        <CommonCardHeader title={SingleFileuploadTitle} subTitle={fileUploadData} />
        <CardBody className="custom-dropzone">
          <CommonFileUpload />
        </CardBody>
      </Card>
    </Col>
  );
}
